import { useState } from "react";

// 2.5.D.2: age-public-key näkymä + copy-to-clipboard.
// Read-only — käyttäjä ei voi vaihtaa avainta UI:sta (daemon hallinnoi).

export function AgeKeyDisplay({ value }: { value: string | null }) {
  const [copied, setCopied] = useState(false);

  if (!value) {
    return (
      <p className="mt-2 text-sm italic text-slate-500">
        Ei vielä ladattu. Käynnistä daemon Macilla — public-key ladataan
        ensimmäisessä käynnistyksessä.
      </p>
    );
  }

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value!);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard-API ei tueta jossain ympäristöissä; fallback: select-all
    }
  }

  return (
    <div className="mt-2 flex items-center gap-2">
      <code className="flex-1 select-all rounded bg-slate-800 px-3 py-2 font-mono text-xs text-slate-200">
        {value}
      </code>
      <button
        type="button"
        onClick={handleCopy}
        className="rounded bg-slate-700 px-3 py-2 text-xs font-medium text-slate-100 hover:bg-slate-600"
      >
        {copied ? "Kopioitu!" : "Kopioi"}
      </button>
    </div>
  );
}
